// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"4e652bae","346":"c7c84a33","624":"2c3c52de","862":"e5836f0f"}[chunkId] + ".chunk.js";
};